import { Flex, Heading } from "@chakra-ui/react";
import React from "react";
import CardDetails from "./CardDetails";

export default function RegistrationSuccess({ data }) {
  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center">
      <Heading size="md" mb={4}>
        Pendaftaran Berhasil
      </Heading>
      <CardDetails data={data} />
    </Flex>
  );
}
